module.exports = __webpack_public_path__ + "static/work28-6244d8bb0dae7c119b3fa0e4c409e669.jpg";